import AsyncBlockService from 'services/async-block-service';
var BlockView = require('views/block/base-block-view');
var CourseSettingsService = require('services/course-settings-service');
var LocaleService = require('services/locale-service');
var MenuService = require('services/menu-service');
const AudioService = require('services/audio-service');

var ModuleView = BlockView.extend({
  regions: {
    'modules': '.modules'
  },
  initialize: function() {
    this.items = EF.modules;
    var menuSettings = CourseSettingsService.get('menu');

    if(menuSettings.hide) {
      this.items = this.items.filter(function(module) {
        return menuSettings.hide.indexOf(module.get('key')) === -1;
      });
    }

    var group = EF.groups.currentGroup(MenuService.getUnlockDay());
    if(MenuService.currentGroup) {
      group = MenuService.currentGroup;
      this.items = group.get('modules');
    } else if(this.model.get('group_id')) {
      group = EF.groups.find({ id: this.model.get('group_id') });
      this.items = group.get('modules');
    }

    if(!(this.items instanceof Chaplin.Collection)) {
      this.items = new Chaplin.Collection(this.items);
    }
    this.model.set('group', group);
    this.model.set('all_complete', this.items.every(function(m) { return m.get('completed'); }));
    this.model.set('totalModules', this.items.length);
    this.model.set('completedModules', this.items.filter({ completed: true }).length);
    this.model.set('moduleProgressPercentage', this.model.get('completedModules') / this.model.get('totalModules') * 100);
    var data = {
      totalModules: this.model.get('totalModules'),
      completedModules: this.model.get('completedModules')
    };
    this.model.set('moduleProgress', LocaleService.t('moduleProgress', data));
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    AsyncBlockService.load([ 'glossary' ], [ 'views/block/module/module-collection-view' ]).then(([ ModuleCollectionView ]) => {
      var moduleCollectionView = new ModuleCollectionView({
        region: 'modules',
        model: this.model,
        collection: this.items
      });
      this.subview('modules', moduleCollectionView);

      AudioService.loadFakeAudio().done((audio) => {
        if(Object.isExtensible(this)) {
          this.fakeAudio = audio;
        }
      });
      this.delegate('click', '.module-link', () => {
        if(createjs.WebAudioPlugin.context && createjs.WebAudioPlugin.context.state === 'suspended') {
          createjs.WebAudioPlugin.context.resume();
        }
        if(this.fakeAudio) {
          this.fakeAudio.play();
        }
      });
    });
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = ModuleView;
